import { render, staticRenderFns } from "./ApplicationModules.vue?vue&type=template&id=49c18ed3"
import script from "./ApplicationModules.vue?vue&type=script&lang=ts"
export * from "./ApplicationModules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports